import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const GAP_FILLING_NAV: MenuItem[] = [
  { title: 'Math', link: '/math-skills-stack' },
];
